import { Check } from 'lucide-react';
import { MarketplaceLogo } from './MarketplaceLogo';
import { SUPPORTED_MARKETPLACES } from '../config/marketplaces';

/**
 * Visible marketplace selector — avoids Radix Select + logo rendering issues (Amazon invisible).
 */
export default function MarketplacePlatformPicker({ value, onChange, className = '' }) {
  return (
    <div className={`space-y-3 ${className}`} data-testid="marketplace-platform-picker">
      <p className="text-sm font-medium text-slate-700">Select marketplace</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {SUPPORTED_MARKETPLACES.map((mp) => {
          const selected = value === mp.id;
          const isAmazon = mp.id === 'amazon';
          return (
            <button
              key={mp.id}
              type="button"
              onClick={() => onChange(mp.id)}
              className={`relative flex flex-col items-center gap-1.5 rounded-xl border-2 px-3 py-3 text-center transition-all ${
                selected
                  ? 'border-orange-500 bg-orange-50 shadow-md shadow-orange-500/15'
                  : 'border-slate-200 bg-white hover:border-orange-300 hover:bg-orange-50/50'
              } ${isAmazon ? 'sm:col-span-2 ring-1 ring-orange-200' : ''}`}
              data-testid={`platform-pick-${mp.id}`}
              aria-pressed={selected}
            >
              {selected ? (
                <Check className="absolute right-2 top-2 h-4 w-4 text-orange-600" aria-hidden />
              ) : null}
              <MarketplaceLogo marketplace={mp.id} size={isAmazon ? 'lg' : 'md'} />
              <span
                className={`text-xs font-semibold ${selected ? 'text-orange-700' : 'text-slate-700'}`}
              >
                {mp.name}
              </span>
              {isAmazon ? (
                <span className="text-[10px] font-medium uppercase tracking-wide text-orange-600/80">
                  Most popular
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
